export default __webpack_public_path__ + "static/media/ic_olympus.70b17676.svg";